<template>
	<div
		:class="['panel', 'programm_single_price',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div class="price_block theme-inverse">
				<div class="row justify-content-center">
					<div class="col-11 col-md-10 col-lg-10">
						<div
							v-if="isHeaderVisible"
							:class="[
								'panel_header',
								isBrand? 'sk' : '',
							]"
						>
							<h2>{{ block.block_title }}</h2>
						</div>
					</div>
				</div>

				<div class="row justify-content-center ">
					<div class="col-11 col-md-10 col-lg-5">
						<div class="price-item cost d-flex h-100 align-items-center">
							<div v-if="block.sellable_program">
								<div
									v-if="block.sellable_program.price && discount"
									:class="'price-common' + getCurrencyClassPostfix(block.sellable_program.currency)"
								>
									{{ formatPrice(block.sellable_program.price) }}
								</div>
								<div
									v-if="block.sellable_program.individual_price && discount"
									:class="'price-discount' + getCurrencyClassPostfix(block.sellable_program.currency)"
								>
									<span v-if="block.sellable_program.individual_price && discount">
										{{ formatPrice(block.sellable_program.individual_price) }}
									</span>
								</div>
								<div v-if="!discount" class="price">
									{{ formatPrice(block.sellable_program.price) }}
								</div>
								<!-- <p class="icon-exclam">
									1 800 000 руб после 30 апреля
								</p> -->
							</div>
							<div v-else>
								<div v-if="!discount" class="price">
									{{ formatPrice(block.price) }}
								</div>
							</div>
						</div>
					</div>

					<div class="col-11 col-md-10 col-lg-5">
						<div class="price-item conditions">
							<div class="title">
								{{ block.title }}
							</div>
							<!-- <div class="description">
								<p>При оплате ранее чем  за 2 недели до старта курса - скидка 15%</p>
							</div> -->
						</div>
					</div>
				</div>

				<div class="row justify-content-center">
					<div class="col-11 col-md-10 col-lg-5">
						<div class="price-item registration">
							<button
								v-if="fetchedData.status && block.sellable_program !==null"
								v-scroll-to="'#empty-registration'"
								class="btn"
								@click="selectDonationProject(block.sellable_program.id)"
							>
								Купить
							</button>
							<button
								v-else
								v-scroll-to="'#empty-registration'"
								class="btn"
								@click="selectProgram(block.title)"
							>
								{{ $t('signUp') }}
							</button>
						</div>
					</div>

					<div class="col-11 col-md-10 col-lg-5">
						<div class="price-item info">
							<div class="description" v-html="block.description" />
						</div>
					</div>
				</div>
			</div>

			<div v-if="block.loyalty_dynamic" class="price_block theme-inverse mt-1">
				<div v-if="loyaltyDynamicData" class="row justify-content-center">
					<div class="col-11 col-md-10 col-lg-10">
						<template v-if="loyaltyDynamicData.type === 0">
							<div class="title title-lg">
								{{ $t('priceWithFullCharge') }}
							</div>

							<div class="price-box w-100">
								<div
									:class="[
										block.sellable_program && discount
											? 'price-discount' + getCurrencyClassPostfix(block.sellable_program.currency)
											: 'price'
									]"
								>
									{{ formatPrice(loyaltyDynamicData.value) }}
								</div>
							</div>
						</template>
						<template v-else-if="loyaltyDynamicData.type === 1">
							<div class="title title-lg">
								{{ $t('xPointsWillBeCredited', { points: $points(loyaltyDynamicData.value) }) }}
							</div>
						</template>
						<div v-else class="price-item">
							<div class="title title-lg mb-3">
								{{ $t('xPointsWillBeCreditedAfterRegistration', { points: $points(loyaltyDynamicData.value) }) }}
							</div>

							<a
								class="btn"
								@click="$router.push('/loyalty-system/')"
							>
								{{ $t('moreDetails') }}
							</a>
						</div>
					</div>
				</div>
			</div>

			<div v-if="isFooterVisible" class="disclaimer mt-3">
				<p>{{ block.footer_description }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';
import moment from '~/utils/moment';

export default {
	name: 'StaticPrice01',
	mixins: [panel],
	data() {
		return {
			discount: false,
			loyaltyDynamicData: null,
		};
	},
	created() {
		this.checkDate();
		this.processLoyalty();
	},
	methods: {
		getCurrencyClassPostfix(type) {
			return {1: '', 2: '-usd', 3: '-eur', 4: '-cny'}[type];
		},

		/**
			 * Зависит от наличия на странице блока panel-smart-form
			 */
		selectDonationProject(programId) {
			if (
				typeof this.$parent.$refs['panel-smart-form'] === 'undefined'
				|| !(0 in this.$parent.$refs['panel-smart-form'])
			) {
				return;
			}

			this.$parent.$refs[
				'panel-smart-form'
			][0].selectSellableProgramAndScroll(programId);
		},

		selectProgram(programTitle) {
			if (
				typeof this.$parent.$refs['panel-smart-form'] === 'undefined'
				|| !(0 in this.$parent.$refs['panel-smart-form'])
			) {
				return;
			}

			this.$parent.$refs['panel-smart-form'][0].setRegistrationProgram(programTitle);
		},

		formatPrice(value) {
			const val = (value / 1).toFixed(2).replace('.00', '');
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		},
		checkDate() {
			const today = moment().endOf('day');
			if (this.block.sellable_program) {
				const active = this.block.sellable_program.active_to;
				const check = moment(today).isSameOrBefore(active, 'day');
				if (check) {
					this.discount = true;
				}
			}
		},
		async processLoyalty() {
			if (! this.block.loyalty_dynamic) {
				return;
			}

			let profile;

			if (this.$auth?.user?.loyalty_id) {
				const { data } = await this.$api.getLoyaltyProfile();

				if (data) {
					profile = data;
				}
			}

			const block = this.block;
			const program = block.sellable_program;
			const price = program?.price ?? block.price ?? block.base_price;
			let result;
			let type;

			if (program && program.currency !== 1) {
				return null;
			}
			const fetchPoints = async (program, isCharge) => {
				return Math.abs(
					parseFloat((await this.$api.getTransactionInfoByProgram(
						program.id,
						program.price,
						isCharge,
						false,
					)).points)
				)
			}

			if (profile) {
				if (Number(profile.points) > 0) {
					type = 0;
					result = Math.ceil(program
						? program.price - await fetchPoints(program, true)
						: price - Math.min(
						price * profile.level.max_payment_percent / 100,
						profile.points
					));
				} else {
					type = 1;
					result = Math.trunc(program
						? await fetchPoints(program, false)
						: price * profile.level.program_percent / 100);
				}
			} else {
				type = 2;
				result = Math.trunc(price * 5 / 100);
			}

			this.loyaltyDynamicData = {type, value: result};
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/prog-single-price";
</style>
